import { css, keyframes } from 'emotion';
import { GrowLoaderProps } from '.';

const grow = keyframes`
0% {
  left: 0;
  right: 100%;
}
25% {
  left: 0;
  right: 0;
}
50%{
  left: 100%;
  right: 0;
}
75% {
  left: 0;
  right: 0;
}
100% {
  left: 0;
  right: 100%;
}
`;

export namespace styles {
  export const container = (color: GrowLoaderProps['color']) =>
    css({
      height: 20,
      position: 'relative',
      width: '100%',
      '::after': {
        content: '""',
        position: 'absolute',
        top: '50%',
        left: '0',
        right: '100%',
        height: 2,
        opacity: 1,
        background: color,
        animation: `${grow} 2s cubic-bezier(0.23, 1, 0.32, 1) infinite`
      }
    });
}
